import { render, staticRenderFns } from "./CompaniesEdit.vue?vue&type=template&id=0c42028e&scoped=true&"
import script from "./CompaniesEdit.vue?vue&type=script&lang=js&"
export * from "./CompaniesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c42028e",
  null
  
)

export default component.exports